<div class="admin-container" [hidden]="!isLoaded" style="width: 98vw; margin-left: -240px;">
  <mat-toolbar class="no-background">
    <span>【管理者用】月報</span>
    <span class="spacer"></span>
    <a mat-button class="add-link" routerLink="/admin">
      <mat-icon>arrow_back</mat-icon>戻る
    </a>
  </mat-toolbar>


  <div>
    <div style="display: flex; justify-content: space-around; border: 1px solid #ccc; border-radius: 8px; padding: 8px; margin-bottom: 8px;">
        <button matFab (click)="changeAd(prevAd)">◀</button>
        <div style="font-size: 26px; font-weight: bold;">{{ym}}</div>

        <div style="margin-top: 9px;">
          　【先月の月報】=
          @if (last && last.reports_count > 0) {
            {{last.reports_count}}件
            （{{last.status}}）
          }
          @else {
            無し
          }

          　【当月の月報】=
          @if (index && data) {
            {{data.length}}件
            （{{index.status}}）
          }
          @else {
            無し
          }

          　【週報】=
          @if (!pl) {
            無し
          }
          @else if (pl && pl[0].is_public) {
            公開状態（{{rateAvailable}}）
          }
          @else {
            集計中（{{rateAvailable}}）
          }

        </div>

        <button mat-raised-button (click)="export()" *ngIf="data">
          CSVダウンロード
        </button>

        <button matFab (click)="changeAd(nextAd)">▶</button>
    </div>

    <div>
      <mat-stepper #stepper class="no-click-stepper">
        <mat-step [label]="'処理開始前'" [completed]="stepper.selectedIndex > 0">
          <div class="stepper-text">
            先月の月報が公開状態になっており、当月の週報に為替レートがセットされていれば、「月報データ初期作成」を押下して月初処理に進めます。<br>
            @if (isCreatable) {
              <button mat-raised-button color="primary" type="button" (click)="createMonthly()">月報データ初期作成</button>
            }
          </div>
        </mat-step>
        <mat-step  [label]="'月初処理中'" [completed]="stepper.selectedIndex > 1">
          <div class="stepper-text">
            <button mat-raised-button color="primary" type="button" (click)="revert()">月報破棄(開発用)</button>

            <div>
              当月の運用開始に必要な情報を入力してください。<br>
              週報が完成して公開され、月末の処理に進める状態になれば、「月末処理に進む」ボタンを押下してください。
            </div>

            <button mat-raised-button color="primary" type="button" (click)="newAccount()">新規口座登録</button>

            @if (isReadyToEndProcessing) {
              <button mat-raised-button color="primary" type="button" (click)="stepToEndProcessing()">月末処理に進む</button>
            }
          </div>
        </mat-step>
        <mat-step  [label]="'月末処理中'" [completed]="stepper.selectedIndex > 2">
          <div class="stepper-text">
            <div>
              その他手数料・年金用出金・出金・振替などを入力してください。<br>
              全ての口座の入力が完了し、確認が終了したら、「月末を確定する」ボタンを押下してください。
            </div>
            @if (true || 'TODO: 何か先に進める条件が必要？') {
              <button mat-raised-button color="primary" type="button" (click)="changeStep('月初処理中')">月初処理に戻る</button>
              <button mat-raised-button color="primary" type="button" (click)="finalize()">月報を確定する</button>
            }
          </div>
        </mat-step>
        <mat-step [label]="'月報確定（非公開）'" [completed]="stepper.selectedIndex > 3">
          <div class="stepper-text">
            <div>
              公開前にユーザーの損益計算ページを確認して、修正箇所がある場合は「月末処理に戻る」ボタンを押下してください。<br>
              確認が完了したら、「月報を公開する」ボタンを押下してください。
            </div>
            @if (true || 'TODO: 何か先に進める条件が必要？') {
              <button mat-raised-button color="primary" type="button" (click)="changeStep('月末処理中')">月末処理に戻る</button>
              <button mat-raised-button color="primary" type="button" (click)="publish()">月報を公開する</button>
            }
          </div>
        </mat-step>
        <mat-step [label]="'公開状態'" [completed]="stepper.selectedIndex > 4">
          <div class="stepper-text">
            <div>
              ユーザーが当月の月報を参照できる状態です。<br>
            </div>
            @if (true || 'TODO: 元に戻ってはいけない条件がある？（翌月のデータが生成済みとか？）') {
              <button mat-raised-button color="primary" type="button" (click)="unpublish()">「月報確定（非公開）」に戻る</button>
            }
          </div>
        </mat-step>
      </mat-stepper>
    </div>
  </div>

  <div *ngIf="this.data !== undefined">
    <div class="list-container">
      <ag-grid-angular
        #grid
        class="ag-theme-alpine compact-grid"
        style="width: 100%; height: calc(100vh - 300px);"
        [localeText]="localeText"
        [defaultColDef]="defaultColDef"
        [columnDefs]="columnDefs"
        [getRowId]="getRowId"
        (gridReady)="onGridReady($event)"
        (rowDoubleClicked)="onRowClicked($event)"
        [rowSelection]="{mode: 'singleRow', enableClickSelection: true, checkboxes: false}"
      >
      </ag-grid-angular>
    </div>
  </div>

  <button mat-raised-button color="primary" type="button" (click)="newAccount(true)">個別口座の履歴再構築モードで口座を追加</button>

</div>
